module.exports = __webpack_public_path__ + "img/3.e835c31a.png";